import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import MeasurementUnitServices from "./MeasurementUnit.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getMeasurementUnit = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MEASUREMENT_UNIT,
      payload: true,
    });
    const resp = await MeasurementUnitServices.getMeasurementUnit(filters);
    dispatch({
      type: actions.GET_MEASUREMENT_UNIT,
      payload: {
        measurementUnits: resp.data.data,
        measurementUnitsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.MEASUREMENT_UNIT_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.MEASUREMENT_UNIT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MEASUREMENT_UNIT,
      payload: false,
    });
  }
};

export const getMeasurementUnitById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MEASUREMENT_UNIT,
      payload: true,
    });
    const resp = await MeasurementUnitServices.getMeasurementUnitById(id);
    dispatch({
      type: actions.GET_MEASUREMENT_UNIT,
      payload: {
        measurementUnit: resp.data
      },
    });
    dispatch({
      type: actions.MEASUREMENT_UNIT_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.MEASUREMENT_UNIT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MEASUREMENT_UNIT,
      payload: false,
    });
  }
};

export const saveMeasurementUnit = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_MEASUREMENT_UNIT,
      payload: true,
    });
    const resp = await MeasurementUnitServices.saveMeasurementUnit(data);
    const { measurementUnits, measurementUnitsLength } = getState().measurementUnit;
    const _measurementUnit = [...measurementUnits, resp.data];
    dispatch({
      type: actions.GET_MEASUREMENT_UNIT,
      payload: {
        measurementUnits: _measurementUnit,
        measurementUnitsLength: measurementUnitsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_MEASUREMENT_UNIT,
      payload: false,
    });
  }
};

export const editMeasurementUnit = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_MEASUREMENT_UNIT,
      payload: true,
    });
    const resp = await MeasurementUnitServices.editMeasurementUnit(id, data);
    const { measurementUnits, measurementUnitsLength } = getState().measurementUnit;
    measurementUnits[index] = resp.data;
    dispatch({
      type: actions.GET_MEASUREMENT_UNIT,
      payload: {
        measurementUnits: measurementUnits,
        measurementUnitsLength: measurementUnitsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MEASUREMENT_UNIT,
      payload: false,
    });
  }
};

export const deleteMeasurementUnit = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_MEASUREMENT_UNIT,
      payload: true,
    });
    await MeasurementUnitServices.deleteMeasurementUnit(id);
    const { measurementUnits, measurementUnitsLength } = getState().measurementUnit;
    measurementUnits.splice(index, 1);
    dispatch({
      type: actions.GET_MEASUREMENT_UNIT,
      payload: {
        measurementUnits: measurementUnits,
        measurementUnitsLength: measurementUnitsLength - 1,
      },
    });
    dispatch({
      type: actions.MEASUREMENT_UNIT_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.MEASUREMENT_UNIT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MEASUREMENT_UNIT,
      payload: false,
    });
  }
};
